import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@mui/material/Grid2";
/**
 * Display navigation and content in vertical layout
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationNavigationVertical(props) {
    return (_jsxs(Grid, { container: true, direction: "row", spacing: 2, children: [_jsx(Grid, { size: {
                    xs: 12,
                    md: 4,
                    lg: 3,
                    xl: 2,
                }, children: props.navigation }), _jsx(Grid, { size: {
                    xs: 12,
                    md: 8,
                    lg: 9,
                    xl: 10,
                }, children: props.content })] }));
}
//# sourceMappingURL=SubconfigurationNavigationVertical.js.map